import { Gauge } from "lucide-react";
import {
  LamaReportOverviewParamsSchema,
  defaultLamaReportOverviewParams,
  type LamaReportOverviewOutput,
  type LamaReportOverviewParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { LamaReportOverviewWidget } from "./Component.js";

/**
 * LAMA Report Overview — dashboard-only report section (plan §13.3).
 * Params are `{}`-strict; `TView` is the `lama/report-overview@1` dataset
 * output resolved through the widget's template-owned connection. The
 * canvas-only `SqlWidgetDef` fields are neutral filler.
 */
export const lamaReportOverviewDef: SqlWidgetDef<
  LamaReportOverviewParams,
  LamaReportOverviewOutput
> = {
  kind: "lamaReportOverview",
  label: "Report Overview",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 960, h: 240 },
  defaultParams: defaultLamaReportOverviewParams,
  Component: LamaReportOverviewWidget,
  storage: "sql",
  schema: LamaReportOverviewParamsSchema,
  accent: "cyan",
  icon: Gauge,
  subtitle: "Headline maturity, participation, confidence",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 1, width: 960, height: 240 },
  dashboard: {
    icon: Gauge,
    defaultWidth: "full",
    category: "Operations",
    supportsTitleOverride: true,
  },
};

registerWidget(lamaReportOverviewDef);
